import { appsignal } from './appsignal';

const { ENABLE_ERROR_LOGGING } = process.env;

/**
 * @typedef Metadata
 * @type {object}
 * @property {string?} context string identifier to determine the location
 * @property {object?} params  meant for `span.setParams()` !! no nested objects
 */

/**
 * Sends an error log to AppSignal.
 *
 * @param {Error}     error
 * @param {Metadata}  metadata
 * @returns {void}
 */
export const error = async (err, metadata = null) => {
  if (ENABLE_ERROR_LOGGING === undefined && ENABLE_ERROR_LOGGING === 'false') {
    console.warn(err, { metadata });
    return;
  }

  appsignal.sendError(err, (span) => {
    const { context, params } = metadata;

    if (context) {
      span.setTags({ context });
    }

    if (params) {
      span.setParams(params);
    }
  });
};

export default {
  error,
};
